

import type { Extensions } from "@tiptap/core";

export const CoreEditorAdditionalExtensionsWithoutProps: Extensions = [];
